import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import theme from './theme';
import { Amplify } from "aws-amplify";
import { ToastContainer } from 'react-toastify';
import { UserProvider } from './components/UserContext';

// Configure Amplify
const config = {
  Auth: {
    Cognito: {
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      region: process.env.REACT_APP_AWS_REGION,
      loginWith: {
        email: true,
        phone: false,
        username: true,
      },
      authenticationFlowType: "USER_SRP_AUTH",
    },
  },
};

Amplify.configure(config);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <UserProvider>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          "*": {
            fontFamily: `'DM Sans', sans-serif`,
          },
          body: {
            margin: 0,
            fontFamily: `'DM Sans', sans-serif`,
          },
        }}
      />
      <ToastContainer />
      <App />
    </ThemeProvider>
  </UserProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
